import React from "react";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import loginIllustration from "../../Assets/login.png";
import icon from "../../Assets/icon_white.png";
import { translation } from "../../i18n/translationConstant";
import "./index.css";

const SignUpPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="homePageRoot">
      {/* Background decorative shapes */}
      <div className="homePageDecor homePageDecorTop" />
      <div className="homePageDecor homePageDecorBottom" />

      {/* Brand */}
      <div className="loginBrandBlock">
        <img
          className="loginBrandLogo"
          src={icon}
          alt="INK Account Aggregator"
        />

        <Typography.Text className="loginBrandTagline">
          {t(translation.lblOneConsentSmarterYou)}
        </Typography.Text>
      </div>

      {/* Main message */}
      <div className="loginWelcomeContent">
        <Typography.Title level={1} className="loginWelcomeTitle">
          {t(translation.lblStartYour)}
          <br />
          {t(translation.lblInkJourney)}
        </Typography.Title>

        <Typography.Paragraph className="loginWelcomeDescription">
          {t(translation.lblCreateYourAccountSecurely)}
          <br />
          {t(translation.lblShareManageFinancial)}
          <br />
          {t(translation.lblDataWithTrustedInstitutions)}
        </Typography.Paragraph>
      </div>

      {/* Illustration */}
      <div className="loginIllustrationWrapper">
        <img
          src={loginIllustration}
          className="loginIllustration"
          alt="Securely manage your financial data with INK-AA"
        />
      </div>

      {/* Trust points */}
      <div className="loginTrustSection">
        <div className="loginTrustItem">
          <div className="loginTrustIcon">✓</div>

          <Typography.Text className="loginTrustTitle">
            {t(translation.lblYourData)}
            <br />
            {t(translation.lblYourControl)}
          </Typography.Text>
        </div>

        <div className="loginTrustDivider" />

        <div className="loginTrustItem">
          <div className="loginTrustIcon">⌂</div>

          <Typography.Text className="loginTrustTitle">
            {t(translation.lblSecure)}
            <br />
            {t(translation.lblRbiRegulated)}
          </Typography.Text>
        </div>

        <div className="loginTrustDivider" />

        <div className="loginTrustItem">
          <div className="loginTrustIcon">▤</div>

          <Typography.Text className="loginTrustTitle">
            {t(translation.lblTransparency)}
            <br />
            {t(translation.lblAtEveryStep)}
          </Typography.Text>
        </div>
      </div>
    </div>
  );
};

export default SignUpPage;